import React from "react";
import "./SearchCard.scss";


function SearchCard({item,select}) {

    return(
        <div className="add-card-container" style={{justifyContent:"flex-end"}} onClick={()=>{
            item['quantity'] = 1;
            select(item)
        }}>
            <div className="add-card-info">
                <div className="add-card-info-label">
                    <span className="name">{item.name}</span>
                    <span className="price">{item.price} تومان </span>
                </div>
                <img style={{margin:'0 4px'}} src={item.image} alt=""/>
            </div>
        </div>
    )

}

export {SearchCard}
